import type { MiddlewareConfig } from './middlewareComposer.ts';
import { createSSRFetch, createSSRTestFetch } from './ssrFetch.ts';
import { createNetworkStatusMiddleware } from './networkStatusMiddleware.ts';
import { createStatusCodeRetryMiddleware } from './StatusCodeRetryMiddleware.ts';

export interface MiddlewareEnvironment {
	isSSR: boolean;
	isSSRTest: boolean;
}

/**
 * Returns middleware configuration for Relay network layer.
 * Middlewares applied in order: SSRFetch, SSRTestFetch, NetworkStatus, StatusCodeRetry.
 */
export const getMiddlewareConfig = (env: MiddlewareEnvironment): MiddlewareConfig[] => {
	const { isSSR, isSSRTest } = env;

	return [
		{
			name: 'SSRFetch',
			factory: createSSRFetch,
			enabled: isSSR,
		},
		{
			name: 'SSRTestFetch',
			factory: createSSRTestFetch,
			enabled: isSSR && isSSRTest,
		},
		{
			name: 'NetworkStatus',
			factory: createNetworkStatusMiddleware,
			enabled: !isSSR,
		},
		{
			name: 'StatusCodeRetry',
			factory: createStatusCodeRetryMiddleware,
			enabled: !isSSR,
		},
	];
};
